import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type HolidayRecurrence = "ONE_TIME" | "YEARLY";

export interface IBusinessHoliday {
  id: string;
  businessId: string;
  holidayDate: string;
  name: string;
  description: string | null;
  isFullDay: boolean;
  recurrence: HolidayRecurrence;
  createdByUserId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ICreateHolidayInput {
  holidayDate: string;
  name: string;
  description?: string | null;
  isFullDay?: boolean;
  recurrence?: HolidayRecurrence;
}

export const list = async (data?: {
  filter?: { yearFrom?: string; yearTo?: string };
  offset?: { limit: number; skip: number };
}) =>
  httpRequest.post("/ord/holiday-calendar/list", (data ?? {}) as never) as Promise<{
    rows: IBusinessHoliday[];
    count: number;
  }>;

export const create = async (input: ICreateHolidayInput): Promise<IBusinessHoliday> =>
  httpRequest.post("/ord/holiday-calendar", input as never);

export const update = async (
  id: string,
  patch: Partial<ICreateHolidayInput>,
): Promise<IBusinessHoliday> =>
  httpRequest.put(`/ord/holiday-calendar/${id}`, patch as never);

export const remove = async (id: string) =>
  httpRequest.del(`/ord/holiday-calendar/${id}`);
